export default "__VITE_ASSET__0kWQm5sc__"